import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import {
  CBadge,CCard,CCardBody,CButton,CCardHeader,CCol,
  CDataTable,CDropdown, CDropdownToggle, CDropdownMenu,
  CRow,CPagination,CModal,CModalHeader,CModalBody, CSwitch,
  CModalFooter,CForm,CFormGroup,CFormText, CDropdownItem,
  CLabel,CInput,CInputGroup,CInputGroupText, CCardTitle, CTextarea
} from 'compat/coreui'
import { ToastContainer, toast } from 'react-toastify';

import moment from 'moment';
import GMap from '../../../components/Signup/GMap';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { EditorState } from 'draft-js';
import { postData, getData } from '../../../helpers/api';
import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';

const weekday = [
  {
    name: "Monday",
    value: true
  }, {
    name: "Tuesday",
    value: true
  }, {
    name: "Wednesday",
    value: true
  }, {
    name: "Thursday",
    value: true
  }, {
    name: "Friday",
    value: true
  }, {
    name: "Saturday",
    value: true
  }, {
    name: "Sunday",
    value: true
  }
];

const EditProfile = (props) => {
  const history = useNavigate();
  const [userData, setUserData] = useState({})
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [showHours, setShowHours] = useState(false);
  const [businessName, setBusinessName] = useState("");
  const [businessType, setBusinessType] = useState("");
  const [businessEmail, setBusinessEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [webUrl, setWebUrl] = useState("");
  const [address, setAddress] = useState("");
  const [address2, setAddress2] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [operationTime, setOperationTime] = useState("");
  const [pincode, setPincode] = useState("");
  const [fax, setFax] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [alternatePhone, setAlternatePhone] = useState("");
  const [alternateEmail, setAlternateEmail] = useState("");
  const [recreational, setRecreational] = useState(false);
  const [creditCard, setCreditCard] = useState(false);
  const [terminalDiscount, setTerminalDiscount] = useState(false);
  const [varientDiscount, setVeteranDiscount] = useState(false);
  const [deliveryHours, setDeliveryHours] = useState(false);
  const [hoursOperationTime, setHoursOperationTime] = useState(weekday.map(day => ({
    day: day.name,
    isWorking: false,
    from: '',
    to: '',
    whole_day: true
  })))

  function onChangetime(value) {
    console.log("value ===>", value );
  }


  useEffect(async () => {
    console.log(recreational)
      getUser()
  }, [])

    const getUser = () => {
      getData(`${process.env.REACT_APP_APP_API_URL}/api/user`).then(res => {
        if (res.data.status) {
          setAddress(res.data.user.address1)
          setAddress2(res.data.user.address2)
          setBusinessName(res.data.user.businessName)
          setBusinessEmail(res.data.user.businessEmail)
          setBusinessType(res.data.user.businessType)
          setCity(res.data.user.city)
          setState(res.data.user.state)
          setPhone(res.data.user.ownerPhone)
          setPincode(res.data.user.pincode)
          setFax(res.data.user.fax)
          setFirstName(res.data.user.manager.firstName)
          setLastName(res.data.user.manager.lastName)
          setAlternatePhone(res.data.user.manager.alternatePhone)
          setAlternateEmail(res.data.user.manager.alternateEmail)
          setWebUrl(res.data.user.website)
        }
      }).catch(console.log)
    }

  const mapStyles = {
        width: '100%',
        height: '400px',
        position: 'relative'
      };


  const deliveryHourHandler = (i) =>{
    console.log('hour handler', i);
    setDeliveryHours(!deliveryHours)
  }

  const editProfile = (e) => {
    e.preventDefault();
    const data = {
        "businessName": businessName,
        "businessEmail":  businessEmail,
        "phone": phone,
        "webUrl": webUrl,
        "businessType": businessType,
        "address": address,
        "address2": address2,
        "city": city,
        "state": state,
        "operationTime": "All",
        "pincode": pincode,
        "fax": fax,
        // "manager": ,
        "recreational": recreational,
        "ageLimit": "",
        "creditCard": true,
        "varientDiscount": true,
        "terminalDiscount": false,
        "fbUrl": "",
        "twitterUrl": "",
        "instaUrl":"" ,
        "pintrestUrl": "",
        "googleUrl": "",
        "onlineOrder": "",
        "taxRate":"",
        "deliveryMinimum":"",
        "deliveryHours":"",
        "allowGuests": false,
        "withoutIdOrder": false,
        "phoneVerify": true,
        "about":"about testing",
        "note":"note testing",
        hours_of_operation: hoursOperationTime,
        manager:{
          firstName:firstName,
          lastName: lastName,
          alternateEmail:alternateEmail,
          alternatePhone:alternatePhone,
        }
      }

        postData(`${process.env.REACT_APP_APP_API_URL}/api/editprofile`, data).then(res => {
          if(res.data.status == 200){
            toast.success('Profile edited successfully')
          }else{
            toast.error(res.data.message);
          }
        }).catch(console.log)
      }

  const onEditorStateChange = (editorState) => {
    setEditorState(editorState);
  }
  return (
    <>
      <CRow>
        <CCol className="text-right mb-5"><CButton color="success" className="profile-btn" onClick={editProfile}>SAVE PROFILE</CButton></CCol>
      </CRow>
      <CRow className="edit_profile_page">
        <CCol xl={6}>
          <CCard>
            <CCardHeader>
              Business Information
            </CCardHeader>
            <CCardBody>
              <CForm className="clearfix">
                <CFormGroup>
                  <CRow>
                    <CCol lg={6}>
                        <CLabel>Business Name<span className="required">*</span></CLabel>
                        <CInput
                          type="text"
                          className="form-control"
                          name="businessName"
                          value={businessName}
                          onChange={(e) => setBusinessName(e.target.value)}/>
                    </CCol>
                    <CCol lg={6}>
                      <CLabel>Business Type<span className="required">*</span></CLabel>
                      <select type="select" className="custom-select " value={businessType} onChange={(e) => setBusinessType(e.target.value)}>
                        <option value="">Select </option>
                        <option value="dispensary">Dispensary</option>
                        <option value="delivery service">Delivery Service</option>
                        <option value="doctor">Doctor</option>
                        <option value="smoke shop">Shop</option>
                        <option value="send bank">Seed Bank</option>
                      </select>
                    </CCol>
                  </CRow>
                </CFormGroup>
                <CFormGroup>
                  <CRow>
                  <CCol lg={6}>
                      <CLabel>Phone<span className="required">*</span></CLabel>
                      <CInput value={phone} onChange={(e) => setPhone(e.target.value)} type="text" className="form-control" name="phone" />
                  </CCol>
                  <CCol lg={6}>
                      <CLabel>Fax</CLabel>
                      <CInput value={fax} onChange={(e) => setFax(e.target.value)} type="text" className="form-control" name="Fax" />
                  </CCol>
                  </CRow>
                </CFormGroup>
                <CFormGroup>
                <CRow>
                  <CCol lg={12}>
                      <CLabel>Website<span className="required">*</span></CLabel>
                      <CInput value={webUrl} onChange={(e) => setWebUrl(e.target.value)} type="text" className="form-control" name="webUrl" />
                  </CCol>
                  </CRow>
                </CFormGroup>
                <CRow>
                    <CCol lg={12} className="pt-5 pb-5 manager-info">
                      <span>Manager Information</span> <span>(private)</span>
                    </CCol>
                </CRow>
                <CFormGroup >
                  <CRow className="mt-4">
                    <CCol lg={6}>
                        <CLabel>First Name</CLabel>
                        <CInput value={firstName} onChange={(e) => setFirstName(e.target.value)} type="text" className="form-control" name="firstName" />
                    </CCol>
                    <CCol lg={6}>
                        <CLabel>Last Name</CLabel>
                        <CInput value={lastName} onChange={(e) => setLastName(e.target.value)} type="text" className="form-control" name="lastName" />
                    </CCol>
                  </CRow>
                </CFormGroup>
                <CFormGroup>
                <CRow>
                  <CCol lg={6}>
                      <CLabel>Alternate Email</CLabel>
                      <CInput value={alternateEmail} onChange={(e) => setAlternateEmail(e.target.value)} type="email" className="form-control" name="alternateEmail" />
                  </CCol>
                  <CCol lg={6}>
                      <CLabel>Alternate Phone</CLabel>
                      <CInput value={alternatePhone} onChange={(e) => setAlternatePhone(e.target.value)} type="text" className="form-control" name="alternatePhone" />
                  </CCol>
                  </CRow>
                </CFormGroup>
              </CForm>
            </CCardBody>
          </CCard>
        </CCol>
        <CCol xl={6}>
          <CCard>
            <CCardHeader className="a">
              Business Location
            </CCardHeader>
            <CCardBody>
              <CForm className="clearfix">
                <CFormGroup>
                  <CRow>
                    <CCol lg={6}>
                        <CLabel>Address<span className="required">*</span></CLabel>
                        <CInput value={address} onChange={(e) => setAddress(e.target.value)} type="text" className="form-control" name="address" />
                    </CCol>
                    <CCol lg={6}>
                      <CLabel>Address 2</CLabel>
                      <CInput value={address2} onChange={(e) => setAddress2(e.target.value)} type="text" className="form-control" name="address2" />
                  </CCol>
                  </CRow>
                </CFormGroup>
                <CFormGroup>
                  <CRow>
                  <CCol lg={6}>
                      <CLabel>City<span className="required">*</span></CLabel>
                      <CInput value={city} onChange={(e) => setCity(e.target.value)} type="text" className="form-control" name="city" />
                  </CCol>
                  <CCol lg={3}>
                      <CLabel>State<span className="required">*</span></CLabel>
                      <CInput value={state} onChange={(e) => setState(e.target.value)} type="text" className="form-control" name="state" />
                  </CCol>
                  <CCol lg={3}>
                        <CLabel>Zip</CLabel>
                        <CInput value={pincode} onChange={(e) => setPincode(e.target.value)} type="text" className="form-control" name="pincode" />
                    </CCol>
                  </CRow>
                </CFormGroup>
                  <CRow>
                    <CCol lg={12}>
                       <div className="map_style">
                        <GMap />
                      </div>
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol lg={12} className="mt-4 text-center">
                      <CButton color="success" className="marker-btn" variant="outline">Need More Map Markers?</CButton>
                    </CCol>
                  </CRow>
              </CForm>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
      <CRow className="edit_profile_page">
        <CCol xl={6}>
          <CCard>
            <CCardHeader>
              Hours of Operation
            </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol>
                  {hoursOperationTime.map((w, i) => <div key={i} className="step-switch p-3">
                    <span className="name_css">{w.day}</span>
                    <div className="d-flex">
                      <CSwitch
                        color="success"
                        shape="pill"
                        size="lg"
                        variant="3d"
                        value={w.isWorking}
                        onChange={(e,value) => {
                          var _hours = hoursOperationTime.slice()
                          _hours[i].isWorking = !_hours[i].isWorking
                          setHoursOperationTime(_hours)
                        }}
                      />
                      {(!w.whole_day) && <React.Fragment>
                        <TimePicker
                          style={{ width: 100 }}
                          showSecond={false}
                          className="xxx"
                          defaultValue={moment()}
                          onChange={onChangetime}
                        />,<TimePicker
                          style={{ width: 100 }}
                          showSecond={false}
                          className="xxx"
                          defaultValue={moment()}
                          onChange={onChangetime}
                        />
                      </React.Fragment>}
                      <div className="time_css">
                        <input type="checkbox" name="operationTime" checked={w.whole_day}
                          onChange={(e,value) => {
                            var _hours = hoursOperationTime.slice()
                            _hours[i].whole_day = !_hours[i].whole_day
                            setHoursOperationTime(_hours)
                          }}
                        />
                        <CLabel>24 Hours</CLabel>
                      </div>
                    </div>
                    </div>)}
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>
        <CCol xl={6}>
          <CCard className="bizFeature-card">
            <CCardHeader className="a">
               Business Features
            </CCardHeader>
            <CCardBody>
              <CRow className="p-3">
                <CCol lg={6} >
                    <div className="d-flex step-switch">
                      <CSwitch
                        color="success"
                        shape="pill"
                        size="lg"
                        variant="3d"
                        onChange={() => setRecreational(!recreational)}
                      />
                      <CLabel>Recreational</CLabel>
                    </div>
                </CCol>
                 <CCol lg={6}>
                    <div className="d-flex">
                      <select type="select">
                        <option value="">Select... </option>
                        <option value="18+Ok">18+Ok</option>
                        <option value="19+Ok">19+Ok</option>
                        <option value="21+Ok">21+Ok</option>
                      </select>
                      <CLabel>Age Requirement</CLabel>
                    </div>
                </CCol>
              </CRow>
              <CRow className="p-3">
                <CCol lg={6}>
                    <div className="d-flex step-switch">
                      <CSwitch
                        color="success"
                        shape="pill"
                        size="lg"
                        variant="3d"
                        onChange={() => setCreditCard(!creditCard)}
                      />
                      <CLabel>Credit Cards Accepted</CLabel>
                    </div>
                </CCol>
                 <CCol lg={6}>
                    <div className="d-flex step-switch">
                      <CSwitch
                        color="success"
                        shape="pill"
                        size="lg"
                        variant="3d"
                        onChange={() => setVeteranDiscount(!varientDiscount)}
                      />
                      <CLabel>Veteran Patient Discount</CLabel>
                    </div>
                </CCol>
              </CRow>
              <CRow className="p-3">
                <CCol lg={6}>
                    <div className="d-flex step-switch">
                      <CSwitch
                        color="success"
                        shape="pill"
                        size="lg"
                        variant="3d"
                        onChange={() => setTerminalDiscount(!terminalDiscount)}
                      />
                      <CLabel>Terminal Patient Discount</CLabel>
                    </div>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
      <CRow className="edit_profile_page">
        <CCol xl={6}>
          <CCard >
            <CCardHeader>
              Social Media Profiles
            </CCardHeader>
            <CCardBody>
              <CFormGroup>
                  <CRow>
                  <CCol lg={6}>
                      <CLabel>FACEBOOK.COM/</CLabel>
                      <CInput type="text" className="form-control" name="facebook" />
                  </CCol>
                  <CCol lg={6}>
                      <CLabel>TWITTER.COM/</CLabel>
                      <CInput type="text" className="form-control" name="twitter" />
                  </CCol>
                  </CRow>
                </CFormGroup>
                <CFormGroup>
                  <CRow>
                    <CCol lg={6}>
                        <CLabel>INSTAGRAM.COM/</CLabel>
                        <CInput type="text" className="form-control" name="insta" />
                    </CCol>
                    <CCol lg={6}>
                        <CLabel>PINTEREST.COM/</CLabel>
                        <CInput type="text" className="form-control" name="pinterest" />
                    </CCol>
                  </CRow>
                </CFormGroup>
                <CFormGroup>
                  <CRow>
                    <CCol lg={6}>
                        <CLabel>PLUS.GOOGLE.COM/</CLabel>
                        <CInput type="text" className="form-control" name="googleplus" />
                    </CCol>
                  </CRow>
                </CFormGroup>
            </CCardBody>
          </CCard>
        </CCol>
        <CCol xl={6}>
          <CCard className="bizreview_card">
            <CCardHeader>
              Review Settings
            </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol lg={12}>
                  <p>You have the option of delaying user reviews for up to 24 hours
                   so you may monitor and respond to your customers.</p>
                </CCol>
                <CCol lg={6}>
                    <div className="d-flex step-switch">
                      <CSwitch
                        color="success"
                        shape="pill"
                        size="lg"
                        variant="3d"
                      />
                      <CLabel>24 Hour Review Delay</CLabel>
                    </div>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
      <CRow className="edit_profile_page">
        <CCol xl={12}>
          <CCard>
            <CCardHeader>
            Online Pre-Ordering
            </CCardHeader>
            <CCardBody>
              <CRow className="mb-3">
                 <CCol lg={6}>
                    <CRow>
                    <CCol lg={6}>
                          <CLabel>ONLINE ORDERING STATUS:</CLabel>
                          <select type="select" className="custom-select status">
                            <option value="on">ON</option>
                            <option value="off">OFF</option>
                          </select>
                      </CCol>
                      <CCol lg={6} className="pt-4">
                        <CButton color='success' variant="outline" className="pre-orderbtn">View Pre-Orders</CButton>
                      </CCol>
                    </CRow>
                    <CRow>
                        <CCol lg={6} >
                            <CLabel>Tax Rate</CLabel>
                            <div className="tax-input"><CInput type="text" className="form-control" name="tax" /><span>%</span></div>
                            <small>If left blank, tax will be included in the product pricing</small>
                        </CCol>
                        <CCol lg={6} className="ml-auto">
                            <CLabel>DELIVERY MINIMUM</CLabel>
                            <div className="tax-input"><span className="ml-0">$</span><CInput type="text" className="form-control" name="delivery" /></div>
                        </CCol>
                    </CRow>
                    <CRow>
                    <CCol lg={6} >
                      <div className="step-switch">
                        <CSwitch
                          color="info"
                          shape="pill"
                          size="lg"
                          variant="3d"
                        />
                      </div>
                      <CLabel>Allow Guests (Unregistered Users)</CLabel>
                      </CCol>
                    </CRow>
                    <CRow>
                    <CCol lg={6} >
                      <div className="step-switch">
                        <CSwitch
                          color="info"
                          shape="pill"
                          size="lg"
                          variant="3d"
                        />
                      </div>
                      <CLabel>Allow Orders without IDs</CLabel>
                      </CCol>
                    </CRow>
                    <CRow>
                    <CCol lg={6} >
                      <div className="step-switch">
                        <CSwitch
                          color="info"
                          shape="pill"
                          size="lg"
                          variant="3d"
                        />
                      </div>
                        <CLabel>Require Phone Verification</CLabel>
                      </CCol>
                    </CRow>
                 </CCol>
                 <CCol lg={6}>
                    <h2>DELIVERY HOURS</h2>
                    {weekday.map((w, i) => <div key={i} className="step-switch p-3">
                      <span className="name_css">{w.name}</span>
                      <div className="d-flex">
                        <CSwitch
                          color="success"
                          shape="pill"
                          size="lg"
                          variant="3d"
                          onChange={(e) => deliveryHourHandler(i)}
                        />
                        {!deliveryHours && <CLabel>CLOSED</CLabel>}
                      </div>
                      {deliveryHours && <div className="time_css">
                        <input type="checkbox" name= "operationTime" />
                        <CLabel>24 Hours</CLabel>
                      </div>}
                    </div>)}
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
      <CRow className="edit_profile_page editor-card">
        <CCol xl={12}>
        <CCard>
        <CRow>
          <CCol lg={6}>
          <CCard className="editor-card">
            <CCardHeader>
            About Your Business
            </CCardHeader>
            <CCardBody>
              <div className="edit_page-editor">
                <Editor
                  editorState={editorState}
                  toolbarClassName="toolbarClassName"
                  wrapperClassName="wrapperClassName"
                  editorClassName="editorClassName"
                  onEditorStateChange={onEditorStateChange}
                />
              </div>
            </CCardBody>
          </CCard>
          </CCol>
          <CCol lg={6}>
          <CCard className="editor-card">
            <CCardHeader>
            First Time Patients
            </CCardHeader>
            <CCardBody>
              <CTextarea type="text" name="note" className="note"/>
            </CCardBody>
          </CCard>
          </CCol>
          </CRow>
          </CCard>
        </CCol>
        <CCol lg={12} className="text-center mb-5"><CButton color="success" className="profile-btn" onClick={editProfile}>SAVE PROFILE</CButton></CCol>
      </CRow>
    </>
  )
}

export default EditProfile;
